import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import {
  detectBrowserLanguage,
  getLanguageByCode,
  persistLanguage,
  readStoredLanguage,
} from '../i18n/languages';
import { MESSAGES } from '../i18n/messages';

const LanguageContext = createContext(null);

function applyDocumentLanguage(code) {
  const meta = getLanguageByCode(code);
  if (typeof document !== 'undefined') {
    document.documentElement.lang = meta.htmlLang;
  }
}

export function LanguageProvider({ children }) {
  const [language, setLanguageState] = useState(() => readStoredLanguage() || detectBrowserLanguage());

  useEffect(() => {
    applyDocumentLanguage(language);
  }, [language]);

  const setLanguage = (code) => {
    const next = getLanguageByCode(code).code;
    persistLanguage(next);
    setLanguageState(next);
    applyDocumentLanguage(next);
  };

  const value = useMemo(() => {
    const meta = getLanguageByCode(language);
    const t = MESSAGES[language] || MESSAGES.en;
    return { language, setLanguage, t, meta };
  }, [language]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return ctx;
}
